import Input from "./Input";
import Button from "./Button";
import ActionButton from "./ActionButton";
import Checkbox from "./Checkbox";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import MultipleCheckbox from "./MultipleCheckbox";
import InputSearch from "./InputSearch";
import AdministrativeSelect from "./AdministrativeSelect";

const Controls = {
  Input,
  Button,
  ActionButton,
  Checkbox,
  RadioGroup,
  Select,
  MultipleCheckbox,
  InputSearch,
  AdministrativeSelect,
};

export default Controls;
